/** Member hub for brief, proposal, and project setup. */
export const MEMBER_GET_STARTED_PATH = "/get-started";

/**
 * Member routes allowed before the project brief is submitted.
 * Must stay in sync with sidebar/dashboard links shown during onboarding.
 */
export const MEMBER_ALLOWED_BEFORE_BRIEF = [
  "/dashboard",
  MEMBER_GET_STARTED_PATH,
  "/onboarding",
  "/project-brief",
  "/project",
  "/features",
  "/client-resources",
  "/schedule-call",
] as const;

/** Routes accessible to profiles with role `member` (client portal). */
export const MEMBER_PORTAL_PREFIXES = [
  "/dashboard",
  MEMBER_GET_STARTED_PATH,
  "/onboarding",
  "/project-brief",
  "/project-briefs",
  "/proposal",
  "/projects",
  "/tech-setup",
  "/project",
  "/packages",
  "/client-resources",
  "/features",
  "/schedule-call",
] as const;

export function isMemberPortalPath(path: string): boolean {
  const normalized = path.replace(/\/+$/, "") || "/";
  return MEMBER_PORTAL_PREFIXES.some(
    (prefix) => normalized === prefix || normalized.startsWith(`${prefix}/`),
  );
}

export function isMemberAllowedBeforeBrief(path: string): boolean {
  const normalized = path.replace(/\/+$/, "") || "/";
  return MEMBER_ALLOWED_BEFORE_BRIEF.some(
    (prefix) => normalized === prefix || normalized.startsWith(`${prefix}/`),
  );
}
